__turbopack_context__.v({
  "buttons": "termsAndConditions-module-scss-module__bQievG__buttons",
  "content": "termsAndConditions-module-scss-module__bQievG__content",
  "decline": "termsAndConditions-module-scss-module__bQievG__decline",
  "decline-btn-group": "termsAndConditions-module-scss-module__bQievG__decline-btn-group",
  "error": "termsAndConditions-module-scss-module__bQievG__error",
  "loader": "termsAndConditions-module-scss-module__bQievG__loader",
  "modal": "termsAndConditions-module-scss-module__bQievG__modal",
  "modal-decline": "termsAndConditions-module-scss-module__bQievG__modal-decline",
  "status-container": "termsAndConditions-module-scss-module__bQievG__status-container",
});
